import ContactSupportComponent from "views/Unauthenticated/Registerv2/Steps/ContactDetails";
import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";


export default class HelpStep extends React.Component {

    render() {
        return <Fragment>
            <StepQuestion>
                You can contact our support desk using the following methods:
                <br/>
                <br/>
                <ContactSupportComponent
                    emailAddress={this.props.emailAddress}
                />
            </StepQuestion>
            <br/>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                Back
            </StepButton>
        </Fragment>
    }
}